import { Card, Col, Row } from 'antd';
import React, { useContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import Title from 'components/atoms/Title';
import LoadingWrapper from 'components/hoc/LoadingWrapper';
import { Context } from 'components/hoc/Store';
import TranslateText from 'components/hoc/TranslateText';
import AkcionarCard from 'components/molecules/Akcionar/AkcionarCard';

import prehledApi, { IPrehled } from 'services/akcionar/prehled';
import nastavitUcetApi from 'services/nastavitUcet';

interface IPrehledAkcionar {}

const PrehledAkcionar: React.FC<IPrehledAkcionar> = () => {
    const { aktivniFirma } = useContext(Context);
    const [prehled, setPrehled] = useState<IPrehled[]>([]);
    const [errMessage, setErrMessage] = useState<string>();
    const [loading, setLoading] = useState<boolean>(false);
    const location = useLocation();
    // spoustet effect vzdy kdyz se zmeni url, toto je hlavne pro prepinani prehledu pres AppMenu
    useEffect(() => {
        setLoading(val => !val);
        setErrMessage('');
        nastavitUcetApi(aktivniFirma ? aktivniFirma.iducet : 0).then(() =>
            prehledApi()
                .then(resp => setPrehled(resp))
                .catch((err: any) => setErrMessage(err.response?.data.message))
                .finally(() => setLoading(val => !val))
        );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location]);
    return (
        <>
            <Title level={3} text="SPRAVA_MEJTOK_UCTU" />
            <Row gutter={8}>
                <Col span={8}>
                    <Card className="dash-card" title={<TranslateText>AKCIONAR_PROFIL_MAJETKOVY_UCET</TranslateText>}>
                        <Title text="CISLO_UCTU" level={5} />
                        <p>{aktivniFirma?.spolecnost}</p>
                        <Title text="KONTAKT_MAJITEL_UCTU" level={4} />
                        <Title text="EMAIL" level={5} />
                        <p>{aktivniFirma?.email}</p>
                        <Title text="TELEFON" level={5} />
                        <p>{aktivniFirma?.telefon}</p>
                    </Card>
                </Col>
                <Col
                    span={16}
                    style={{
                        alignContent: 'center'
                    }}
                >
                    <LoadingWrapper loading={loading}>
                        {errMessage ? (
                            <Title text="AKCIONAR_ZADNE_UDALOSTI" level={3} />
                        ) : (
                            <AkcionarCard prehled={prehled} />
                        )}
                    </LoadingWrapper>
                </Col>
            </Row>
        </>
    );
};

export default PrehledAkcionar;
